import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { AuctionFacade, ContactOrganizerPayload } from 'libs/gb-front/auction/data-access/src'
import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src'
import { SelectedProfileFacade } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.facade'
import { GbFrontInvisibleRecaptchaComponent } from 'libs/gb-front/shared/feature/src/lib/gb-front-invisible-recaptcha/gb-front-invisible-recaptcha.component'
import * as AuctionActions from 'libs/gb-front/auction/data-access/src/lib/+state/auction.actions'

@UntilDestroy()
@Component({
  selector: 'gb-auction-contact-dialog',
  templateUrl: './gb-auction-contact-dialog.component.html',
  styleUrls: ['./gb-auction-contact-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbAuctionContactDialogComponent implements OnInit {
  @ViewChild(GbFrontInvisibleRecaptchaComponent)
  recaptcha!: GbFrontInvisibleRecaptchaComponent

  form: FormGroup = new FormGroup({})
  profile?: ProfileEntity

  constructor(private selectedProfileFacade: SelectedProfileFacade, private auctionFacade: AuctionFacade) {}

  ngOnInit(): void {
    this.selectedProfileFacade.selectedProfile$.pipe(untilDestroyed(this)).subscribe((profile) => {
      this.profile = profile
      this.initForm()
    })
  }

  initForm(): void {
    const email: string = this.profile?.email || ''
    this.form = new FormGroup({
      message: new FormControl('', [Validators.required]),
      email: new FormControl(
        {
          value: email,
          disabled: !!email,
        },
        [Validators.required, Validators.email],
      ),
    })
  }

  onSubmit(captchaResponse: string): void {
    const payload: ContactOrganizerPayload = {
      ...this.form.value,
      grecaptcha_token: captchaResponse,
    }
    this.auctionFacade.dispatch(AuctionActions.contactOrganizerSend({ payload }))
  }

  recaptchaExecute(): void {
    this.recaptcha.execute()
  }
}
